import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=71caaaa6&scoped=true&"
import script from "./DataGrid.vue?vue&type=script&lang=js&"
export * from "./DataGrid.vue?vue&type=script&lang=js&"
import style0 from "./DataGrid.vue?vue&type=style&index=0&id=71caaaa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71caaaa6",
  null
  
)

export default component.exports